import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'react/components/Modal';
import { getResourceTo } from 'react/utils/utils';
import { LookupField, GroupField, TextField } from 'react/components/fields';

const GroupsFieldsModal = ({ closeModalFn, modalIsOpen }) => {
  const buttonLabel = getResourceTo('samlConfiguration.button.close');
  const groupModalSubtitle = getResourceTo(
    'groupsFieldMappingModal.label.title'
  );

  const Footer = () => (
    <>
      <input type="button" value={buttonLabel} onClick={closeModalFn} />
    </>
  );

  return (
    <Modal
      className="fieldMappingModal groupMapping"
      isOpen={modalIsOpen}
      title={Monet.I18n.getResourcesByKey(
        'groupsFieldMappingModal.label.title'
      )}
      closeModalFn={closeModalFn}
      crossAxisBtn={false}
      footer={<Footer />}
    >
      <p className="fieldMappingModal-label">{groupModalSubtitle}</p>
      <GroupField name="idp.groupMappings">
        <TextField
          label="samlConfiguration.indentityProviderGroup"
          description="assertionFieldName"
          name="assertionFieldName"
        />
        <div className="arrowRight" />
        <LookupField
          label="samlConfiguration.greenmileGroups"
          name="value"
          lookupEntity="Group"
          lookupEntityColumn="name"
          multiple
        />
      </GroupField>
    </Modal>
  );
};

GroupsFieldsModal.propTypes = {
  closeModalFn: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  modalIsOpen: state.samlConfiguration.getIn(
    ['modals', 'groups', 'modalIsOpen'],
    false
  )
});

export default connect(mapStateToProps)(React.memo(GroupsFieldsModal));
